import React from 'react'

type Props = Omit<React.ComponentProps<'input'>, 'className' | 'type'>

function SponsorCheckbox(props: Props) {
  return (
    <input
      className="form-checkbox rounded border border-grey-tertiary-10 bg-transparent text-green focus:ring-2 focus:ring-green"
      type="checkbox"
      {...props}
    />
  )
}

export default SponsorCheckbox
